var AttachmentsCollection = /** @class */ (function () {
    function AttachmentsCollection(atts) {
        this.attachments = atts;
    }
    AttachmentsCollection.prototype.attachmentsNamesAreUnique = function () {
        var _this = this;
        if (this.attachments.length <= 1) {
            return true;
        }
        var attachmentNames = this.attachments.filter(function (x) { return x.name; }).map(function (item) { return item.name; });
        return !(attachmentNames.filter(function (x) { return _this.getHasDuplicates(attachmentNames, x); }).length > 0);
    };
    AttachmentsCollection.prototype.attachmentsFileNamesAreUnique = function () {
        var _this = this;
        if (this.attachments.length <= 1) {
            return true;
        }
        var fileNames = this.attachments.filter(function (x) { return x.fileNameWithExtension; }).map(function (item) { return item.fileNameWithExtension; });
        return !(fileNames.filter(function (x) { return _this.getHasDuplicates(fileNames, x); }).length > 0);
    };
    AttachmentsCollection.prototype.getHasDuplicates = function (array, value) {
        return array.filter(function (v) { return (v === value); }).length > 1;
    };
    return AttachmentsCollection;
}());
export { AttachmentsCollection };
